<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h1>{{$t('target.title')}}</h1>
      </div>
    </div>
    <div v-for="i in Math.ceil(keyOrderedList.length/nbColumn)" :key="i" class="row listOfButtons">
      <div v-for="(item, index) in keyOrderedList.slice((i-1)*nbColumn, (i-1)*nbColumn+nbColumn)"  :key="index" class="col">
        <button :class="'btn btn-secondary ' + ((selectedIndex === (i-1)*nbColumn+index) ? 'bg-color' : '')" @click="saveData((i-1)*nbColumn+index)">{{targetList[item].name}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'target',
  data () {
    return {
      nbColumn: 3,
      selectedIndex: null,
      targetList: {
        weightloss: {name: this.$i18n.t('target.weightloss'), component: 'TargetWeightloss'},
        fitness: {name: this.$i18n.t('target.fitness'), component: 'TargetFitness'},
        zen: {name: this.$i18n.t('target.zen'), component: 'TargetZen'},
        relaxation: {name: this.$i18n.t('target.relaxation'), component: 'TargetRelaxation'},
        bodybuilding: {name: this.$i18n.t('target.bodybuilding'), component: 'TargetBodybuilding'}}
    };
  },
  activated: function () {
    // S'il y a 4 ou moins objectifs activés, on en affiche 2 par colonne
    if (this.keyOrderedList.length <= 4) {
      this.nbColumn = 2;
    } else {
      this.nbColumn = 3;
    }
  },
  methods: {
    saveData: function (index) {
      this.selectedIndex = index;
      this.$store.dispatch('form/FORM_NEXTLAYOUT', {target: {component: this.targetList[this.keyOrderedList[index]].component, key: this.keyOrderedList[index]}});
    },
    isInArray: function (array, item) {
      let test = false;
      array.forEach(function (arrayItem) {
        if (item === arrayItem) {
          test = true;
        }
      });
      return test;
    }
  },
  computed: {
    keyOrderedList: function () {
      return [...this.$store.state.config.target];
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/Target.vue